import { connection } from '../../utils/connection';
import { AUTH_URL } from '../../config/config';

async function agregarUsuarioExistente({ token, params }) {
    return await connection({ method: 'POST', url: `${AUTH_URL.SIGNUP_EXIST}`, params: params, extraHeaders: { token: token } });
}

export default agregarUsuarioExistente;
